import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import ErrorBoundary from '../../components/ErrorBoundary';

const MinimalLayout = props => {
  const { children } = props;

  return (
    <Fragment>
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </Fragment>
  );
};

MinimalLayout.propTypes = {
  children: PropTypes.node
};

export default MinimalLayout;
